export interface Chapter {
  id: string;
  title: string;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  status: string;
  description: string;
  rating: number;
  views: string;
  updatedAt: string;
  chapters: Chapter[];
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const categories = [
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line', description: '激情澎湃的战斗场面，永不言弃的少年梦想' },
  { slug: 'lianai', name: '恋爱', icon: 'ri-heart-line', description: '甜蜜浪漫的恋爱故事，触动心灵的纯爱物语' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line', description: '扑朔迷离的推理谜题，烧脑刺激的悬疑冒险' },
  { slug: 'qihuan', name: '奇幻', icon: 'ri-magic-line', description: '天马行空的异世界冒险，瑰丽壮阔的奇幻旅程' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '轻松幽默的日常趣事，笑料百出的欢乐时光' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line', description: '未来世界的科技畅想，硬核震撼的科幻史诗' },
  { slug: 'wuxia', name: '武侠', icon: 'ri-sword-line', description: '快意恩仇的江湖传奇，侠肝义胆的武林故事' },
  { slug: 'kongbu', name: '恐怖', icon: 'ri-ghost-line', description: '毛骨悚然的惊悚故事，细思极恐的恐怖体验' },
];

export const comics: Comic[] = [
  {
    id: 'spirit-blade',
    title: '灵剑尊者',
    author: '墨染青云',
    cover: 'https://readdy.ai/api/search-image?query=A%20stylized%20Chinese%20martial%20arts%20comic%20cover%20featuring%20a%20young%20swordsman%20with%20flowing%20black%20hair%20holding%20a%20glowing%20spiritual%20sword%2C%20dramatic%20mountain%20landscape%20in%20background%2C%20ethereal%20energy%20effects%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20anime%20style%20illustration%20with%20clean%20lines%2C%20professional%20manga%20cover%20quality&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    category: 'rexue',
    status: '连载中',
    description: '少年林风意外获得远古灵剑传承，从此踏上修炼之路。在强者如云的修真世界中，他凭借过人天赋与坚韧意志，一步步揭开身世之谜，剑指苍穹之巅！宗门争斗、上古秘境、宿命对决，一场惊心动魄的修真之旅就此展开。',
    rating: 9.5,
    views: '1280万',
    updatedAt: '2026-08-08',
    tags: ['修真', '战斗', '成长', '逆袭'],
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch-1', title: '第1话 远古传承', updatedAt: '2026-08-08' },
      { id: 'ch-2', title: '第2话 初入宗门', updatedAt: '2026-08-08' },
      { id: 'ch-3', title: '第3话 试炼之路', updatedAt: '2026-08-07' },
      { id: 'ch-4', title: '第4话 秘境开启', updatedAt: '2026-08-07' },
      { id: 'ch-5', title: '第5话 剑意初成', updatedAt: '2026-08-06' },
    ],
  },
  {
    id: 'sweet-encounter',
    title: '甜蜜邂逅',
    author: '星野琉璃',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20shoujo%20manga%20style%20cover%20illustration%20of%20a%20high%20school%20girl%20and%20boy%20standing%20under%20cherry%20blossom%20trees%2C%20soft%20pink%20and%20pastel%20color%20palette%2C%20delicate%20petals%20falling%20around%20them%2C%20gentle%20spring%20atmosphere%2C%20clean%20anime%20art%20style%2C%20heartwarming%20romantic%20vibe&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    category: 'lianai',
    status: '连载中',
    description: '平凡女高中生苏小糖在一次偶然的校园活动中，邂逅了全校公认的钢琴王子。两个性格截然不同的人，因为一场意外的音乐合作而逐渐拉近距离。甜蜜又带点忐忑的校园恋爱故事，每一个瞬间都让人心动不已。',
    rating: 9.3,
    views: '960万',
    updatedAt: '2026-08-08',
    tags: ['校园', '甜宠', '音乐', '青春'],
    isHot: true,
    isNew: true,
    chapters: [
      { id: 'ch-1', title: '第1话 琴声响起', updatedAt: '2026-08-08' },
      { id: 'ch-2', title: '第2话 意外的搭档', updatedAt: '2026-08-07' },
      { id: 'ch-3', title: '第3话 心跳加速', updatedAt: '2026-08-07' },
    ],
  },
  {
    id: 'shadow-detective',
    title: '暗影侦探',
    author: '夜不语',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20manga%20cover%20showing%20a%20detective%20in%20a%20dark%20trench%20coat%20standing%20in%20a%20rainy%20urban%20alleyway%20at%20night%2C%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20noir%20atmosphere%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20dark%20teal%20and%20amber%20color%20scheme%2C%20suspenseful%20mood&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    category: 'xuanyi',
    status: '已完结',
    description: '退役刑警陆沉开设了一家私人侦探事务所，专门接手警方不愿碰的离奇案件。一桩看似普通的失踪案，却牵出一张横跨整座城市的黑暗网络。真相远比想象的更加骇人，而每一个线索都在指向一个令人窒息的答案。',
    rating: 9.7,
    views: '1560万',
    updatedAt: '2026-07-28',
    tags: ['推理', '犯罪', '都市', '心理'],
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch-1', title: '第1话 失踪者', updatedAt: '2026-07-28' },
      { id: 'ch-2', title: '第2话 第一现场', updatedAt: '2026-07-28' },
      { id: 'ch-3', title: '第3话 蛛丝马迹', updatedAt: '2026-07-27' },
      { id: 'ch-4', title: '第4话 关键证人', updatedAt: '2026-07-27' },
      { id: 'ch-5', title: '第5话 真相浮现', updatedAt: '2026-07-26' },
      { id: 'ch-6', title: '第6话 终章', updatedAt: '2026-07-26' },
    ],
  },
  {
    id: 'another-world-gate',
    title: '异界之门',
    author: '幻月千寻',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20isekai%20manga%20cover%20featuring%20a%20young%20adventurer%20standing%20before%20a%20glowing%20magical%20portal%20gate%2C%20fantasy%20world%20with%20floating%20islands%20and%20castles%20in%20the%20distance%2C%20magical%20particles%20dancing%20in%20the%20air%2C%20vibrant%20emerald%20green%20and%20gold%20color%20palette%2C%20epic%20adventure%20feel&width=400&height=560&seq=comic-cover-04&orientation=portrait',
    category: 'qihuan',
    status: '连载中',
    description: '普通大学生陈凡在一次雷雨夜意外穿越到了名为"天启大陆"的奇幻世界。在这里，魔法与剑术并存，龙族与精灵共存。陈凡发现自己拥有独一无二的"万象之门"能力，能够召唤来自不同世界的伙伴并肩作战。',
    rating: 9.4,
    views: '1120万',
    updatedAt: '2026-08-07',
    tags: ['异世界', '冒险', '魔法', '召唤'],
    isHot: true,
    isNew: false,
    chapters: [
      { id: 'ch-1', title: '第1话 雷雨之夜', updatedAt: '2026-08-07' },
      { id: 'ch-2', title: '第2话 天启大陆', updatedAt: '2026-08-07' },
      { id: 'ch-3', title: '第3话 万象之门', updatedAt: '2026-08-06' },
      { id: 'ch-4', title: '第4话 精灵之森', updatedAt: '2026-08-06' },
    ],
  },
  {
    id: 'laughing-daily',
    title: '爆笑日常',
    author: '豆豆龙',
    cover: 'https://readdy.ai/api/search-image?query=A%20comedy%20slice%20of%20life%20manga%20cover%20with%20exaggerated%20funny%20facial%20expressions%20of%20chibi%20style%20characters%20in%20a%20school%20setting%2C%20bright%20sunny%20yellow%20and%20sky%20blue%20color%20palette%2C%20energetic%20and%20playful%20vibe%2C%20cartoonish%20exaggerated%20style%2C%20multiple%20small%20characters%20doing%20silly%20things&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    category: 'gaoxiao',
    status: '连载中',
    description: '四个性格迥异的高中生的爆笑日常生活。学霸的傲娇、体育生的热血笨蛋行为、文艺少女的脑洞大开、以及转学生的各种神操作，每一话都能让你笑到肚子疼。快乐就是这么简单！',
    rating: 9.1,
    views: '890万',
    updatedAt: '2026-08-08',
    tags: ['日常', '校园', '搞笑', '四格'],
    isHot: false,
    isNew: true,
    chapters: [
      { id: 'ch-1', title: '第1话 转学生来了', updatedAt: '2026-08-08' },
      { id: 'ch-2', title: '第2话 食堂大作战', updatedAt: '2026-08-07' },
    ],
  },
  {
    id: 'star-colony',
    title: '星际殖民',
    author: '星河守望',
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20manga%20cover%20illustration%20of%20a%20futuristic%20spaceship%20captain%20in%20advanced%20armor%20looking%20at%20a%20distant%20galaxy%2C%20stars%20and%20nebula%20in%20the%20background%2C%20sleek%20mecha%20design%20elements%2C%20cool%20silver%20and%20deep%20space%20blue%20color%20palette%2C%20epic%20space%20opera%20aesthetic&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    category: 'kehuan',
    status: '连载中',
    description: '公元2458年，人类已迈入星际殖民时代。年轻的舰队指挥官叶星云率领"先驱者号"探索未知星域，却意外发现了古老外星文明的遗迹。一场关乎人类命运的星际冒险就此展开。',
    rating: 9.2,
    views: '750万',
    updatedAt: '2026-08-06',
    tags: ['星际', '机甲', '探索', '文明'],
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'ch-1', title: '第1话 启航之日', updatedAt: '2026-08-06' },
      { id: 'ch-2', title: '第2话 深空信号', updatedAt: '2026-08-06' },
      { id: 'ch-3', title: '第3话 遗迹', updatedAt: '2026-08-05' },
    ],
  },
  {
    id: 'dragon-river',
    title: '龙江风云',
    author: '寒江孤影',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20wuxia%20martial%20arts%20manga%20cover%20depicting%20a%20lone%20warrior%20with%20long%20sword%20standing%20on%20a%20bamboo%20raft%20on%20a%20misty%20river%2C%20distant%20mountains%20silhouetted%20in%20ink%20wash%20style%2C%20traditional%20Chinese%20painting%20aesthetic%20blended%20with%20modern%20manga%2C%20ink%20black%20and%20vermillion%20red%20accents&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    category: 'wuxia',
    status: '已完结',
    description: '明末清初，龙江之畔，各方势力暗流涌动。少年侠客沈孤鸿身怀绝世武功，却被卷入一场牵扯朝廷与江湖的惊天阴谋。刀光剑影间，忠义与背叛、爱恨与家国，交织成一幅波澜壮阔的江湖画卷。',
    rating: 9.6,
    views: '1350万',
    updatedAt: '2026-07-15',
    tags: ['江湖', '武侠', '历史', '恩怨'],
    isHot: false,
    isNew: false,
    chapters: [
      { id: 'ch-1', title: '第1话 江畔少年', updatedAt: '2026-07-15' },
      { id: 'ch-2', title: '第2话 血染长街', updatedAt: '2026-07-15' },
      { id: 'ch-3', title: '第3话 师门之秘', updatedAt: '2026-07-14' },
      { id: 'ch-4', title: '第4话 龙吟九霄', updatedAt: '2026-07-14' },
      { id: 'ch-5', title: '第5话 大结局', updatedAt: '2026-07-13' },
    ],
  },
  {
    id: 'midnight-whispers',
    title: '午夜低语',
    author: '幽冥书生',
    cover: 'https://readdy.ai/api/search-image?query=A%20horror%20manga%20cover%20with%20a%20creepy%20abandoned%20mansion%20under%20moonlight%2C%20a%20shadowy%20figure%20in%20the%20window%2C%20twisted%20bare%20trees%2C%20foggy%20atmosphere%2C%20dark%20purple%20and%20black%20color%20scheme%20with%20pale%20moonlight%20highlights%2C%20unnerving%20and%20chilling%20vibe&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    category: 'kongbu',
    status: '连载中',
    description: '搬进老旧公寓的大学生周明，每晚午夜都能听到隔壁房间传来诡异的低语声。当他决定调查声音来源时，一系列令人毛骨悚然的事件接连发生。隔壁的房间究竟隐藏着什么秘密？',
    rating: 9.0,
    views: '620万',
    updatedAt: '2026-08-05',
    tags: ['灵异', '惊悚', '都市传说', '悬疑'],
    isHot: false,
    isNew: true,
    chapters: [
      { id: 'ch-1', title: '第1话 新房客', updatedAt: '2026-08-05' },
      { id: 'ch-2', title: '第2话 午夜钟声', updatedAt: '2026-08-05' },
      { id: 'ch-3', title: '第3话 隔壁', updatedAt: '2026-08-04' },
    ],
  },
];

export const testimonials = [
  {
    id: 't1',
    name: '漫画迷小王',
    avatar: '',
    rating: 5,
    content: 'jm漫画真的是我用过最好的漫画平台！更新速度超快，画质清晰，而且免费内容超多。每天晚上睡前必刷，已经成为我生活的一部分了。',
    date: '2026-08-05',
  },
  {
    id: 't2',
    name: '樱花飘落',
    avatar: '',
    rating: 5,
    content: '从大学开始就在jm漫画上看漫画了，陪伴了我整整四年。分类很全，推荐算法也很准，总能找到我喜欢的新作品。界面简洁舒服，阅读体验超棒！',
    date: '2026-08-03',
  },
  {
    id: 't3',
    name: '追更达人阿杰',
    avatar: '',
    rating: 5,
    content: '作为重度漫画爱好者，试过好多平台，最后留在了jm漫画。正版授权看着安心，支持作者。而且App做得特别流畅，离线下载功能通勤必备！',
    date: '2026-08-01',
  },
  {
    id: 't4',
    name: '星月神话',
    avatar: '',
    rating: 4,
    content: '朋友推荐来的，真的很惊喜！热门漫画更新很及时，还有好多独家作品。唯一希望的是能增加更多原创国漫，已经推荐给身边所有喜欢漫画的朋友了。',
    date: '2026-07-28',
  },
];